import { get } from 'lodash';

export const getContactGroups = (state) => get(state, 'contacts.contactGroups', {});
export const getGroupData = (state) => get(state, 'contacts.groupData', []);